/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import useApi from "../services/api";
import { UpdateUser } from "../store/reducers/auth.reducer";
import { handleApiErrors } from "../utils/handleErrors";

import Header from "../components/header/header";

import t from "../i18n/i18n";

function Template({ children }) {
  const { background } = useSelector((store) => store.theme);
  const { logged } = useSelector((store) => store.auth);

  const dispatch = useDispatch();
  const { ApiGetUser } = useApi();

  async function getUser() {
    const { data } = await ApiGetUser();

    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    dispatch(UpdateUser(data));
  }

  useEffect(() => {
    if (logged) {
      getUser();
    }
  }, []);

  return (
    <div className="app-wrapper">
      <Header />
      <div className={`main-modules ${background}`}>
        {children}

        <div className="bottom-nav">
          <ul>
            <li>
              <a href="#">
                <span className="icon">
                  <img src="/images/home_icon.png" alt="" />
                </span>
                {t("Menu.Home")}
              </a>
            </li>
            <li>
              <a href={t("Config.AboutLink")}>
                <span className="icon">
                  <img src="/images/sobre-ico.png" alt="" />
                </span>
                {t("Menu.About")}
              </a>
            </li>
            <li>
              <a href={t("Config.TermsLink")}>
                <span className="icon">
                  <img src="/images/termos-icon.png" alt="" />
                </span>
                {t("Menu.Terms")}
              </a>
            </li>
            <li>
              <a href={t("Config.PrivacyLink")}>
                <span className="icon">
                  <img src="/images/privacidade-icon.png" alt="" />
                </span>
                {t("Menu.Privacy")}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <footer className="theme-footer">
        <p dangerouslySetInnerHTML={{ __html: t("Footer.Copyright") }} />
      </footer>
    </div>
  );
}

export default Template;
